var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-component"},[_c('div',{staticClass:"footer-content"},[_c('span',[_vm._v("© 2026 哨兵安全监控管理系统")]),_c('span',{staticClass:"footer-divider"},[_vm._v("·")]),_c('span',[_vm._v("杭州众地科技有限公司")])])])
}]

export { render, staticRenderFns }